import { DesignerSetting } from '../../../DesignerSetting';

export function updateLastChange(
  /** Item that was updated. */
  item: {
    /** Username of the user that made the change. */
    author?: string;
    /** Time that the change was made. */
    lastLocalChange?: number;
  }
) {
  item.author = DesignerSetting.s.author;
  item.lastLocalChange = window.apm?.timestamp ?? Date.now();
}
